<template>
  <div class="page drivers">
    <h1>
      Chauffeurs
      <button class="sync" @click="fetchDrivers" title="Synchroniseer">
        <fa-icon icon="sync-alt"></fa-icon>
      </button>
    </h1>
    <div class="drivers__controls">
      <button class="button button--accept" @click="newVisible=true">+ Nieuwe chauffeur</button>
    </div>
    <div class="page__content">
      <Loader v-if="isLoading"></Loader>
      <div class="cardlist" v-else>
        <div class="cardlist__item" v-for="item in drivers" :key="`driver--${item.ID}`">
          <div class="cardlist__item__thumb">
            <img :src="`${imgRoot}${item.FOTO}`" :alt="item.NAAM">
          </div>
          <div class="cardlist__item__content">
            <h2>{{item.NAAM}}</h2>
            <p>login: <b>{{item.LOGIN}}</b></p>
            <p>GSM: <b>{{item.GSM}}</b></p>
            <p>e-mail: <b>{{item.EMAIL}}</b></p>
            <div class="cardlist__item__content__controls">
              <button class="button" @click="editItem=item"><fa-icon icon="edit"></fa-icon></button>
              <button class="button button--cancel" @click="deleteItem=item"><fa-icon icon="trash-alt"></fa-icon></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DriversNew v-if="newVisible" @close-modal="newVisible=false" @data-edit="onUpdate" @preview-click="onPreviewClicked"></DriversNew>
    <DriversEdit v-if="editItem" @close-modal="editItem=null" :item="editItem" :imgRoot="imgRoot" @data-edit="onUpdate" @preview-click="onPreviewClicked"></DriversEdit>
    <DriversDelete v-if="deleteItem" @close-modal="deleteItem=null" @delete-decline="deleteItem=null" @delete-confirm="deleteItemConfirm"></DriversDelete>
    <AssetModal v-if="previewAsset" :asset="previewAsset" @close-asset="previewAsset=null"></AssetModal>
  </div>
</template>

<script>
import Loader from "@/components/Loader";
import AssetModal from "@/components/AssetModal";
import SubcontractorService from "@/services/subcontractor";

import DriversNew from "@/components/Drivers/DriversNew";
import DriversEdit from "@/components/Drivers/DriversEdit";
import DriversDelete from "@/components/Drivers/DriversDelete";

export default {
  name: "Drivers",
  components: {
    Loader,
    AssetModal,
    DriversNew,
    DriversEdit,
    DriversDelete
  },
  data() {
    return {
      isLoading: false,

      editItem: null,
      newVisible: false,
      deleteItem: null,
      previewAsset:null,

      drivers: []
    };
  },
  created(){
    this.fetchDrivers();
  },

  computed:{
    imgRoot(){
      return `${process.env.VUE_APP_ROOT_API}${process.env.VUE_APP_ROOT_API_ENV}/media/partners/`;
    }
  },

  methods:{
    fetchDrivers(){
      this.isLoading = true;
      SubcontractorService.getDrivers(this.$store.state.auth.user.PERS_ID)
        .then(res => {
          if (res.status && res.data) {
            this.drivers = res.data;
          }
          this.isLoading = false;
        })
    },

    deleteItemConfirm(){
      console.log('delete item todo', this.deleteItem);
      SubcontractorService.deleteDriver(this.deleteItem.ID,this.deleteItem.LOGIN)
      .then((res)=>{
        if(res) {
          this.onUpdate();
        }
      });
    },

    onUpdate(){
      this.deleteItem = null;
      this.editItem = null;
      this.newVisible = null;
      this.fetchDrivers();
    },

    onPreviewClicked(asset){
      this.previewAsset=asset;
    }
  }
}
</script>
